import { store as imageStore } from '../../image'
import Command from '../command'


function keyRequired(key, path = null) {
  if (path) {
    path = `.${path}`
  }
  // eslint-disable-next-line max-len
  return `requires \`data.${path}${key}\` (from \`contextStore.target.${key}\`) to be present`
}

export default class RemoveImageFromArticlePlaceholderCommand extends Command {

  constructor(data) {

    super(data)

    this.data = data

  }

  validate(data) {

    return ['article', 'pid']
      .filter(key => !(key in data) || !data[key])
      .map(key => keyRequired(key))
      .concat(
        ['value']
          .filter(key => data.image && (!(key in data.image) || !data.image[key]))
          .map(key => keyRequired(key, 'image'))
      )
      .join(', ')

  }

  exec() {

    const placeholderData = this.data.article.getDataInPlaceholder(this.data.pid)
    const defaultLang = this.data.article.createdIso

    // If languageReferences are provided, remove from those languages
    // Otherwise, remove from the current language only
    const languagesToRemove = this.data.languageReferences || [defaultLang]

    this.data.article
      .removeDataInPlaceholder(`${this.data.pid}*`)

    if (placeholderData && placeholderData.id) {
      // Return the promise so caller can await deletion
      return imageStore.destroy(placeholderData.id, languagesToRemove)
        .catch((err) => {
          // eslint-disable-next-line max-len
          console.warn(`The image with the id '${placeholderData.id} could not be deleted: ${err.message}'`)
        })
    }

    // If nothing to delete, still return a resolved promise for consistency
    return Promise.resolve()
  }


}
